export const calculateCaseEditorProgress = (availableSteps = [], completionStates = []) => {
  const totalStepCount = Array.isArray(availableSteps) ? availableSteps.length : 0;
  const completedStepCount = Array.from(
    { length: totalStepCount },
    (_, index) => Boolean(completionStates[index])
  ).filter(Boolean).length;

  return {
    completedStepCount,
    totalStepCount,
    progressPercent: totalStepCount > 0
      ? Math.round((completedStepCount / totalStepCount) * 100)
      : 0,
  };
};
